module.exports = __webpack_public_path__ + "static/media/search-gray.61b4c5ab.svg";